export default "__VITE_ASSET__D6bQ13bw__"